import React from 'react';
import {
  Container,
  Paper,
  Grid,
  styled,
  Box,
  useTheme,
} from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { connect, useSelector } from 'react-redux';

import DividerWithText from 'components/DividerWithText';
import { PrimaryButton } from 'components/Button';
import {
  paperStyle,
  StyledGrid,
  BlockIcon,
  StyledIcon,
  StyledGridTitle,
  StyledPageTitle,
  StyledMediumSectionHeader,
  Wrapper,
  BlockImg,
} from 'containers/LoginPage/styles';
import Form from 'containers/LoginPage/Form';
import { isReverse, translate } from 'helpers/intl';
import { pushTo } from 'helpers/routes';
import messages from 'containers/LoginPage/messages';
import { requestLogin } from 'store/user/actions';
import {
  getIsLoginLoadingSelector,
  getErrorMessageSelector,
} from 'store/user/selectors';
import { createStructuredSelector } from 'reselect';
import { SmallSectionHeader, Captions, LongBody } from 'components/Typography';
import PAGES from 'routes/pages';
import { setPasswordRecoveryStep } from 'store/credentials/actions';
import { white } from 'Material-UI/colors';
import { AssuranceIcon } from 'images';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import useMediaQuery from '@material-ui/core/useMediaQuery';
export interface LoginProps {
  intl: IntlShape;
  requestLogin: Function;
  loader: boolean;
  responseErrorMessage: string;
  setPasswordRecoveryStep: Function;
}

const StyledPaper = styled(Paper)({ ...paperStyle });

const LoginForm = (props: LoginProps) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <GaLoadHOC category={EVENT_CATEGORIES.LOGIN}>
      <Wrapper matches={matches} reverse={reverse}>
        <Container maxWidth="lg">
          <Grid>
            <Box py={18} px={matches ? 0 : 3}>
              <Grid container justify="space-between">
                <Grid item xs={matches ? 12 : 5}>
                  <Grid item xs={matches ? 12 : 12}>
                    <StyledPageTitle
                      matches={matches}
                      color={white}
                      weight="100"
                    >
                      <strong>
                        {translate({ ...messages.title }, props)}{' '}
                        {translate({ ...messages.secondTitle }, props)}
                      </strong>
                    </StyledPageTitle>
                  </Grid>
                  <StyledGrid
                    container
                    justify={matches ? 'space-between' : 'flex-start'}
                    matches={matches}
                  >
                    <Grid item xs={3}>
                      <StyledIcon>
                        <img alt="" src={AssuranceIcon['autoLogin']} />
                      </StyledIcon>
                      <SmallSectionHeader color={white} weight="400">
                        {translate({ ...messages.auto }, props)}
                      </SmallSectionHeader>
                    </Grid>
                    <Grid item xs={3}>
                      <BlockIcon>
                        <img alt="" src={AssuranceIcon['habitationLogin']} />
                      </BlockIcon>
                      <SmallSectionHeader color={white} weight="400">
                        {translate({ ...messages.mrh }, props)}
                      </SmallSectionHeader>
                    </Grid>
                    <Grid item xs={3}>
                      <BlockIcon>
                        <img alt="" src={AssuranceIcon['epargnLogin']} />
                      </BlockIcon>
                      <SmallSectionHeader color={white} weight="400">
                        {translate({ ...messages.epargn }, props)}
                      </SmallSectionHeader>
                    </Grid>
                  </StyledGrid>
                  <Grid
                    container
                    direction={matches ? 'column' : 'row'}
                    spacing={3}
                  >
                    <Grid item xs={matches ? 12 : 10}>
                      <Grid container spacing={1}>
                        <Grid item>
                          <BlockImg>
                            <img alt="" src={AssuranceIcon['sinistreLogin']} />
                          </BlockImg>
                        </Grid>
                        <StyledGridTitle item matches={matches}>
                          <LongBody color={white} weight="400">
                            {translate({ ...messages.declaration_tite }, props)}
                          </LongBody>
                        </StyledGridTitle>
                      </Grid>
                    </Grid>
                    <Grid item xs={matches ? 12 : 10}>
                      <Grid container spacing={1}>
                        <Grid item>
                          <BlockImg>
                            <img alt="" src={AssuranceIcon['timelineLogin']} />
                          </BlockImg>
                        </Grid>
                        <StyledGridTitle item matches={matches}>
                          <LongBody color={white} weight="400">
                            {translate({ ...messages.sinistre }, props)}
                          </LongBody>
                        </StyledGridTitle>
                      </Grid>
                    </Grid>
                    <Grid item xs={matches ? 12 : 10}>
                      <Grid container spacing={1}>
                        <Grid item>
                          <BlockImg>
                            <img alt="" src={AssuranceIcon['contractLogin']} />
                          </BlockImg>
                        </Grid>
                        <StyledGridTitle item matches={matches}>
                          <LongBody color={white} weight="400">
                            {translate({ ...messages.contrat_title }, props)}
                          </LongBody>
                        </StyledGridTitle>
                      </Grid>
                    </Grid>
                    <Grid item xs={matches ? 12 : 10}>
                      <Grid container spacing={1}>
                        <Grid item>
                          <BlockImg>
                            <img alt="" src={AssuranceIcon['reportLogin']} />
                          </BlockImg>
                        </Grid>
                        <StyledGridTitle item matches={matches}>
                          <LongBody color={white} weight="400">
                            {translate({ ...messages.epargn_situation }, props)}
                          </LongBody>
                        </StyledGridTitle>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {matches && (
                  <Grid item xs={12} style={{ height: '25px' }}></Grid>
                )}
                <Grid item xs={matches ? 12 : 5}>
                  <Box px={matches ? 0 : 3} mt={matches ? 0 : 9}>
                    <StyledPaper elevation={0}>
                      <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="stretch"
                      >
                        <Grid item>
                          <StyledMediumSectionHeader weight="500">
                            {translate({ ...messages.seConnecter }, props)}
                          </StyledMediumSectionHeader>
                        </Grid>
                        <Form
                          setPasswordRecoveryStep={
                            props.setPasswordRecoveryStep
                          }
                          requestLogin={props.requestLogin}
                          loader={props.loader}
                          responseErrorMessage={props.responseErrorMessage}
                        />
                        <DividerWithText>
                          {translate({ ...messages.or }, props)}
                        </DividerWithText>
                        <Captions>
                          {translate({ ...messages.firstVisit }, props)}
                        </Captions>
                        <GaClickHOC
                          category={EVENT_CATEGORIES.LOGIN}
                          label="créer un compte"
                        >
                          <PrimaryButton
                            variant="outlined"
                            onClick={() => pushTo(PAGES.SIGNUP)}
                          >
                            {translate({ ...messages.createAccount }, props)}
                          </PrimaryButton>
                        </GaClickHOC>
                      </Grid>
                    </StyledPaper>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Wrapper>
    </GaLoadHOC>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  { loader: boolean; responseErrorMessage: string }
>({
  loader: getIsLoginLoadingSelector,
  responseErrorMessage: getErrorMessageSelector,
});

const mapDispatchToProps = {
  requestLogin,
  setPasswordRecoveryStep,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LoginForm));
